import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';

import { defineCustomElements as ionicElements } from '@ionic/pwa-elements/loader';
import { defineCustomElements as stripeElements } from 'stripe-pwa-elements/loader';

//import { defineCustomElements } from '@ionic/pwa-elements/loader';
//import { defineCustomElements } from 'stripe-pwa-elements/loader';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(async err => {
    

    if (Capacitor.isNativePlatform()) {
      await new Promise<void>(resolve => {
        requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
      });
      await SplashScreen.hide().catch(error => {
        
      });
    }
  });

// Carrega os componentes web de cada biblioteca separadamente
ionicElements(window);
stripeElements(window);
